import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Mail } from 'react-feather'
import godrej from '../../../assets/images/userScreen/unnamed.png'
import '../sass/footer.scss'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchHomeList } from '../../home/store'

const Footer = () => {
  const { homeList } = useSelector((state) => state.home)
  const dispatch = useDispatch()
  const openCompose = () => {
    window.location.href = 'mailto:gpl.alchemy@godrejproperties.com'
  }

  const faqArray = homeList?.filter((e) => e.key === 'FAQ_PDF')
  const aboutArray = homeList?.filter((e) => e.key === 'ABOUT_US_PDF')
  const policyArray = homeList?.filter((e) => e.key === 'POLICY_PDF')

  const faqStatus = faqArray && faqArray[0]?.flag
  const aboutStatus = aboutArray && aboutArray[0]?.flag
  const policyStatus = policyArray && policyArray[0]?.flag

  let navigate = useNavigate()
  const handleRedirect = () => {
    navigate('/dashboard')
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    dispatch(fetchHomeList())
  }, [])
  return (
    <div id="footer" className="userFooter">
      <div className="userFooter_sec1">
        <div>
          <div className="userFooter_sec1-1">
            {/* <h3>Alchemy Navigation</h3> */}
            <div className="userFooter_sec1-first">
              <div className="userFooter_sec1-first-div1">
                <Link
                  className="userFooter_sec1-first-div1-link"
                  to="/dashboard"
                >
                  Home
                </Link>

                <Link
                  className="userFooter_sec1-first-div1-link"
                  to="/user-learning-tracks"
                >
                  Learning
                </Link>
                <Link
                  className="userFooter_sec1-first-div1-link"
                  to="/user-talent-philosophy"
                >
                  Careers
                </Link>
                <Link
                  className="userFooter_sec1-first-div1-link"
                  to="/my-journey"
                >
                  My Journey
                </Link>
              </div>
            </div>
          </div>
          <div className="userFooter_sec2">
            <div className="userFooter_sec1-first-div2">
              {aboutStatus && (
                <Link
                  className="userFooter_sec1-first-div1-link"
                  to="/about-us"
                >
                  About Us
                </Link>
              )}
              {faqStatus && (
                <Link className="userFooter_sec1-first-div1-link" to="/faq">
                  FAQs
                </Link>
              )}
              {policyStatus && (
                <Link
                  className="userFooter_sec1-first-div1-link"
                  to="policy-document"
                >
                  Policy Document
                </Link>
              )}

              <Link className="userFooter_sec1-first-div1-link" to="#">
                Contact Us
              </Link>
            </div>
          </div>
        </div>

        <div className="userFooter_sec3">
          <span onClick={openCompose}>
            <Mail size={20} /> gpl.alchemy@godrejproperties.com
          </span>
        </div>
        <div className="userFooter_sec4">
          <div className="userFooter_sec3-last">
            <img
              className="userFooter_sec3-last-img"
              src={godrej}
              onClick={handleRedirect}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          width: '100%',
          textAlign: 'center',
          borderTop: '1px solid gray',
          padding: '10px 0px'
        }}
      >
        Copyright © 2023. Godrej Properties Limited
      </div>
    </div>
  )
}

export default Footer
